/**
 * @file ArchiveNotice — shown when a race finishes while replaying an archived
 * week. There is no live leaderboard for past weeks, so instead of ranking we
 * surface this notice. Purely a web-layer overlay; Unity is untouched.
 */

/** @param {{ onClose?: () => void }} props */
export function ArchiveNotice({ onClose }) {
  return (
    <div className="scrw-archive-notice" role="status" aria-live="polite">
      <div className="scrw-archive-notice__card">
        <p className="scrw-archive-notice__title">Archive Challenge</p>
        <p className="scrw-archive-notice__body">
          This week’s leaderboard is no longer active.
        </p>
        {onClose ? (
          <button
            type="button"
            className="scrw-btn scrw-btn--ghost scrw-btn--sm"
            onClick={onClose}
          >
            Dismiss
          </button>
        ) : null}
      </div>
    </div>
  );
}
